<template>
  <div id="NewsDetail" v-wechat-title="pageTitle">
    <ul class="news-header">
      <li>
        {{ newsContent.noticeTitle }}
      </li>
      <!-- <li>{{ dayjs(newsContent.releaseTime).format("YYYY-MM-DD") }}</li> -->
    </ul>
    <div
      v-if="newsContent.noticeForm === '0'"
      :class="newsContentClass"
      ref="newsContent"
      v-html="$xss(newsContent.noticeDescribe)"
      @click="imageChgange($event)"
    ></div>
    <a v-else :href="newsContent.noticeDescribe" class="news-content" ref="import">
      {{ newsContent.noticeDescribe }}
    </a>
    <!-- <img class="test" src="./shuizhi.jpg" alt=""> -->

    <!-- <van-button class="nfr-button" type="info" @click="test">
      放大
    </van-button> -->
  </div>
</template>

<script>
// import dayjs from "dayjs";
import { selectNoticeDetail } from "@/api/user";
import { number } from "echarts/lib/export";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      newsContent: "",
      noticeId: this.$route.query.noticeId,
      pageTitle: this.$route.query.pageTitle,
      newsContentClass: ["news-content"],
      readingNum: 0
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    // dayjs,
    initData() {
      this.$forceUpdate();
      return new Promise((resolve, reject) => {
        selectNoticeDetail(this.noticeId)
          .then(res => {
            let { status, resultData } = res;
            if (status === "complete") {
              this.newsContent = resultData;
              this.readingNum = resultData.readNum;
              if(window.location.origin == 'https://wt.wateryx.com' && this.newsContent.noticeForm === '1') {
                // this.$refs.import.$el.click()
                window.open(this.newsContent.noticeDescribe, '_blank')
                // location.href = this.newsContent.noticeDescribe;
              }
            }
            resolve(resultData);
          })
          .catch(e => {
            console.log(e, "捕获公告详情错误");
            reject(new Error(e));
          });
      });
    },
    addPx(list) {
      list.forEach(item => {
        if (item.style?.fontSize) {
          item.style.fontSize = `${Number(item.style.fontSize.split("px")[0]) + 2}px`;
        } else if (item.style) {
          item.style.setProperty("font-size", "16px", "important");
        }

        if (item.childNodes) {
          this.addPx(item.childNodes);
        }
      });
    },
    test() {
      this.addPx(this.$refs.newsContent.childNodes);
    },
    imageChgange(e) {
      if (e.target.nodeName == "IMG") {
        ImagePreview({
          images: [e.target.currentSrc], //e.target.currentSrc  当前图片src
          closeable: true,
          showIndex: false,
          loop: true,
          closeOnPopstate: true
        });
      } else {
        return;
      }
    }
  }
};
</script>

<style lang="less">
#NewsDetail {
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  font-size: 14px;
  overflow: auto;
  color: #333;
  background-color: #fff;
  .news-header {
    // padding: 0 16px;
    // box-sizing: border-box;

    li:first-child {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
    }
    li:last-child {
      padding-top: 10px;
      color: #c8c8c8;
    }
  }
  .news-content {
    width: 100%;
    // padding: 0 15px;
    // box-sizing: border-box;

    img {
      width: 100% !important;
    }
  }

  .fontSize18 {
    p {
      font-size: 18px;
    }
    span {
      font-size: 18px;
    }
  }

  .fontSize20 {
    p {
      font-size: 20px;
    }
    span {
      font-size: 20px;
    }
  }

  .fontSize22 {
    p {
      font-size: 22px;
    }
    span {
      font-size: 22px;
    }
  }

  .fontSize24 {
    p {
      font-size: 24px;
    }
    span {
      font-size: 24px;
    }
  }
}
</style>
<style lang="less">
.news-content {
  /* https://www.kancloud.cn/wangfupeng/wangeditor3/335775 */
  /* table 样式 */
  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }
  table tr:first-child {
    background-color: #f5f2f0;
  }
  /* blockquote 样式 */
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }
  /* code 样式 */
  code {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }
  pre code {
    display: block;
  }
  /* ul ol 样式 */
  ul,
  ol {
    margin: 10px 0 10px 20px;
  }
}
</style>
